<template>
  <div
    :id="`alert-${uuidv4()}`"
    v-show="visible"
    class="alert component"
    :class="{'alert--fixed': isFixed, 'hidden': !visible}"
    :style="{ backgroundColor: backgroundColor }"
  >
    <div
      class="alert-wrapper"
      :class="[isFixed ? 'contained' : 'container']"
    >
      <div
        ref="alertText"
        class="alert-text"
        :style="{ color: textColor === 'black' ? 'black' : 'white' }"
        v-html="alertMessage"
      />
      <span
        class="alert-icon"
        :class="textColor === 'black' ? 'icon-close-black' : 'icon-close-white'"
        v-if="hasCloseIcon"
        tabindex="0"
        @click.prevent="handleCloseClick"
        @keydown.space.prevent="handleCloseClick"
        :aria-label="tc('booking.close')"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    name: 'Alert',
    props: {
      backgroundColor: {
        default: '#B59060',
        type: String,
      },
      textColor: {
        default: 'black',
        type: String,
      },
      alertLabel: {
        default: '',
        type: String,
      },
      alertLabelButton: {
        default: '',
        type: String,
      },
      externalLink: {
        default: null,
        type: String,
      },
      externalLinkTarget: {
        default: '_blank',
        type: String,
      },
      hotelId: {
        default: null,
        type: String,
      },
      hasCloseIcon: {
        default: false,
        type: Boolean,
      },
      showAlert: {
        default: true,
        type: Boolean,
      },
      isFixed: {
        default: false,
        type: Boolean
      },
      isGlobal: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        visible: false,
        hoursToReopen: 1,
      }
    },
    mounted() {
      this.visible = this.showAlert
      const alertText = this.$refs.alertText
      if (alertText?.children.length > 0) {
        for (let i = 0; i < alertText.children.length; i++) {
          if (alertText.children[i].className.includes('alert-link') ) {
            alertText.children[i].onclick = this.handleLinkClick
            alertText.children[i].onkeypress = (event) => {
              if (event.code == 'Enter') {
                this.handleLinkClick()
              }
            }
          }
        }

      }
      this.checkTimeToReopen()
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      isPropertyPage() {
        return !!this.hotelId
      },
      isExternalLinkModal() {
        return this.externalLinkTarget.includes('external:')
      },
      alertMessage() {
        if (this.alertLabelButton) {
          const alertButtonColor = this.textColor === 'black' ? 'black' : 'white'
          const alertButton = `<a class="alert-link button--text underline size-md ${alertButtonColor}"
          ${this.isExternalLinkModal ? `href="${this.externalLink}" target="${this.externalLinkTarget}"` : ''}
          tabindex="0">
          ${this.alertLabelButton}
        </a>`
          return this.alertLabel.replace('[[alert]]', alertButton)
        }
        return this.alertLabel
      },
      key() {
        return this.hotelId == '' ? 'global' : this.hotelId
      }
    },
    methods: {
      uuidv4,
      handleCloseClick() {
        this.visible = false
        const now = Date.now()
        const hoursToReopenInMs = this.hoursToReopen * 3600000
        const reopenTime = now + hoursToReopenInMs
        localStorage.setItem(`alertBannerTimeToReopen${this.key}`, reopenTime)
        if (this.$root.$refs.stickyHeader && (this.isPropertyPage || this.isGlobal)) {
          this.$root.$refs.stickyHeader.updateSpaceBetweenNavs()
        }
      },
      handleLinkClick() {
        if ((this.isPropertyPage || this.isGlobal) && this.externalLink && !this.isExternalLinkModal) {
          window.open(this.externalLink, this.externalLinkTarget)
        } else if (!this.isGlobal && !this.isExternalLinkModal) {
          this.$emit('open-hotel-alerts')
        }
      },
      checkTimeToReopen() {
        const timeToReopen = localStorage.getItem(`alertBannerTimeToReopen${this.key}`) || null
        const now = Date.now()
        if (timeToReopen && timeToReopen > now) {
          this.visible = false
          return
        }
        this.visible = true
      }
    },
  }
</script>
